// extracted by css-extract-rspack-plugin
export default {"ClosedPositionPnlUnknown":"ClosedPositionPnlUnknown-kSsCDQ","closedPositionPnlUnknown":"ClosedPositionPnlUnknown-kSsCDQ"};